import React from "react";
import { Tab } from "semantic-ui-react";
import { RISK_API_ENDPOINT } from "common";
import RiskThresholdForm from "components/RiskThresholdForm";

export interface Props {
  riskType: string;
  levels: string[];
}

const RiskThresholdMenu = ({ riskType, levels }: Props) => {
  const panes = levels.map((level) => {
    return {
      menuItem: `${level}`,
      render: () => (
        <Tab.Pane>
          <RiskThresholdForm
            endpoint={`${RISK_API_ENDPOINT}/${riskType}/${level}`}
            riskType={riskType}
            riskLevel={level}
          />{" "}
        </Tab.Pane>
      ),
    };
  });

  return (
    <Tab
      id={`tab-${riskType}-form`}
      menu={{ fluid: true, vertical: true, tabular: true }}
      panes={panes}
    />
  );
};

export default RiskThresholdMenu;
